"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

exports.__esModule = true;
exports["default"] = void 0;

var _unicodeProperties = _interopRequireDefault(require("@react-pdf/unicode-properties"));

var _empty = _interopRequireDefault(require("../../attributedString/empty"));

var ignoredScripts = ['Common', 'Inherited', 'Unknown'];
/**
 * Resolves unicode script in runs, grouping equal runs together
 *
 * @param  {Object}  layout options
 * @param  {Object}  attributed string
 * @return {Object} attributed string
 */

var scriptItemizer = function scriptItemizer() {
  return function (attributedString) {
    var string = attributedString.string;
    var lastScript = 'Unknown';
    var lastIndex = 0;
    var index = 0;
    var res = [];
    if (!string) return (0, _empty["default"])();

    for (var i = 0; i < string.length; i += 1) {
      var _char = string[i];

      var codePoint = _char.codePointAt();

      var script = _unicodeProperties["default"].getScript(codePoint);

      if (script !== lastScript && !ignoredScripts.includes(script)) {
        if (lastScript !== 'Unknown') {
          res.push({
            start: lastIndex,
            end: index,
            attributes: {
              script: lastScript
            }
          });
        }

        lastIndex = index;
        lastScript = script;
      }

      index += _char.length;
    }

    if (lastIndex < string.length) {
      res.push({
        start: lastIndex,
        end: string.length,
        attributes: {
          script: lastScript
        }
      });
    }

    return {
      string: string,
      runs: res
    };
  };
};

var _default = scriptItemizer;
exports["default"] = _default;